import { reactive, readonly } from 'vue'
import type {
  DemoTask,
  DemoStep,
  DemoFlow,
  DemoBehaviorType,
  DemoStepBehaviorType,
} from './types'

export interface CompletableDemoTask extends DemoTask {
  completed?: boolean
}

export const defaultState = {
  loaded: false,
  active: false,
  flow: null as DemoFlow | null,
  tasks: [] as CompletableDemoTask[],
  steps: [] as DemoStep[],
  currentTaskIdx: -1,
  currentStepIdx: -1,
  status: 'intro' as 'intro' | 'tasks-overview' | 'task-active' | 'complete',
  stepStatus: 'active' as 'active' | 'complete',
  config: {
    behavior: 'RESTRICTED' as DemoBehaviorType,
    stepBehavior: 'AUTO' as DemoStepBehaviorType,
    completionBehavior: 'AUTO' as DemoStepBehaviorType,
  },
  welcomeShown: false,
}

const startingState = { ...defaultState }

export const _mut_state_dont_use_elsewhere = reactive(startingState)
const state = _mut_state_dont_use_elsewhere
export const demoState = readonly(state)
